import { Button } from "antd";
import { AddCommissionGroupForm } from "components/Forms/AddCommissionGroupForm/AddCommissionGroupForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddCommissionGroupDrawerProps {
    onSubmit: () => void | Promise<void>;
}

export const AddCommissionGroupDrawer: FC<AddCommissionGroupDrawerProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.add-commission-group");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.AddCommissionGroup;
    const formId = FormId.AddCommissionGroup;
    const drawerUtils = useDrawer();

    const handleSubmit = async () => {
        await onSubmit();
        drawerUtils.hide(id);
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={formId}>
                    {tC("save")}
                </Button>
            }
        >
            <AddCommissionGroupForm onSubmit={handleSubmit} formId={formId} />
        </Drawer>
    );
};
